
import { PhoneCall } from "lucide-react";
import { getAssetPath } from "@/utils/assetUtils";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

interface TripActionButtonsProps {
  claimed_by: string | null;
  isCompleted: boolean;
  onClaimTrip?: () => void;
  tripId: string;
  mobile_number?: string;
}

const TripActionButtons = ({ 
  claimed_by, 
  isCompleted, 
  onClaimTrip,
  tripId,
  mobile_number
}: TripActionButtonsProps) => {
  const { toast } = useToast();
  const [isPhoneNumberCopied, setIsPhoneNumberCopied] = useState(false);
  
  // Function to handle phone call or copy phone number to clipboard
  const handleContactRider = () => {
    if (mobile_number) {
      // Try to make a call if on mobile device
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      if (isMobile) {
        window.location.href = `tel:${mobile_number}`;
      } else {
        // Copy to clipboard on desktop
        navigator.clipboard.writeText(mobile_number)
          .then(() => {
            setIsPhoneNumberCopied(true);
            toast({
              title: "Phone number copied!",
              description: `${mobile_number} has been copied to your clipboard.`,
            });
            
            // Reset the copied state after a short delay
            setTimeout(() => {
              setIsPhoneNumberCopied(false);
            }, 3000);
          })
          .catch((err) => {
            console.error("Failed to copy phone number: ", err);
            toast({
              title: "Failed to copy phone number",
              description: "Please try again or copy it manually.",
              variant: "destructive",
            });
          });
      }
    } else {
      toast({
        title: "No phone number available",
        description: "This trip doesn't have a rider phone number associated with it.",
        variant: "destructive",
      });
    }
  };
  
  if (claimed_by === null && !isCompleted) {
    return (
      <div className="w-full pb-5">
        <div className="w-[85%] mx-auto">
          <button 
            className="w-full text-center"
            onClick={() => onClaimTrip && onClaimTrip()}
          >
            <img 
              src={getAssetPath("Claim_Trip_Button.png")} 
              alt="Claim Trip" 
              className="w-full h-auto object-cover"
            />
          </button>
        </div>
      </div>
    );
  }
  
  if (claimed_by && !isCompleted) {
    return (
      <div className="w-full pb-5">
        <div className="w-[85%] mx-auto">
          <button 
            className="w-full text-center"
            onClick={handleContactRider}
          >
            <img 
              src={getAssetPath("Contact_Rider_Button.png")} 
              alt="Contact Rider" 
              className="w-full h-auto object-cover"
            />
          </button>
        </div>
      </div>
    );
  }
  
  if (isCompleted) {
    return (
      <div className="bg-gray-700 text-white w-full py-3 font-medium text-center">
        Completed
      </div>
    );
  }
  
  return null;
};

export default TripActionButtons;
